import React from 'react';
import { Link } from '@reach/router';
import ciegalogo from '../../../src/assets/ciegalogo.png'

const footer= () => (
  <footer className="footer-light"style={{color:'white'}}>
            <div className="container">
                <div className="row">
                   <div className="col-md-3 col-sm-6 col-xs-1">
                        <div className="widget">
                            <h5 style={{color:'white'}}>Ciega Labs</h5>
                            <p>
                               Ciega Labs is a web3 studio focused on making end-to-end defi and metaverse applications for a variety of industries and clients in addition to its own projects. 
                            </p>
                        </div>
                    </div>
                    <div className="col-md-3 col-sm-6 col-xs-1">
                        <div className="widget">
                            {/* <h5 style={{color:'white'}}>Resources</h5>
                            <ul>
                                <li><Link to="">Help Center</Link></li>
                                <li><Link to="">Partners</Link></li>
                                <li><Link to="">Suggestions</Link></li>
                                <li><Link to="">Discord</Link></li>
                                <li><Link to="">Docs</Link></li>
                                <li><Link to="">Newsletter</Link></li>
                            </ul> */}
                        </div>
                    </div> 
                     <div className="col-md-3 col-sm-6 col-xs-1">
                        <div className="widget">
                            <h5 style={{color:'white'}}>Contact</h5>
                           <p>
                        ciegalabs@gmail.com
                            </p>
                            <a style={{color:'white'}} href='/contact'>
                             Use Our Contact Form
                            </a>
                        </div>
                    </div> 
                   <div className="col-md-3 col-sm-6 col-xs-1">
                        <div className="widget">
                            <h5 style={{color:'white'}}>Social Media</h5>
                            <p>Telegram: @edrzo</p>
                            
                         
                          
                        </div>
                    </div> 
                </div>
                <div>
                    <h5 style={{color:'white'}}>Los Angeles, Phoenix</h5>
                </div>
            </div>
            <div className="subfooter">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="de-flex">
                                <div className="de-flex-col">
                                    <span onClick={()=> window.open("", "_self")}>
                                        {/* <img alt="" className="f-logo d-1" src={ciegalogo} style={{height:'2em'}} /> */}
                                        <span className="copy">&copy; Copyright 2024 - Ciega Labs </span>
                                    </span>
                                </div>
                                <div className="de-flex-col">
                                    <div className="social-icons">
                                        {/* <span onClick={()=> window.open("", "_self")}><i className="fa fa-facebook fa-lg"></i></span> */}
                                        {/* <span onClick={()=> window.open("", "_self")}><i className="fa fa-twitter fa-lg"></i></span>
                                        <span onClick={()=> window.open("", "_self")}><i className="fa fa-linkedin fa-lg"></i></span> */}
                                        {/* <span onClick={()=> window.open("", "_self")}><i className="fa fa-pinterest fa-lg"></i></span> */}
                                        {/* <span onClick={()=> window.open("", "_self")}><i className="fa fa-rss fa-lg"></i></span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
);
export default footer;